/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ClassroomdisciplineClassModulesId202,
  PutApiV1ClassroomdisciplineClassModulesId400,
  PutApiV1ClassroomdisciplineClassModulesId401,
  PutApiV1ClassroomdisciplineClassModulesId404,
  PutApiV1ClassroomdisciplineClassModulesId500,
  PutApiV1ClassroomdisciplineClassModulesIdMutationRequest,
  PutApiV1ClassroomdisciplineClassModulesIdMutationResponse,
  PutApiV1ClassroomdisciplineClassModulesIdPathParams,
} from "../../types/classPlanningClassModuleController/PutApiV1ClassroomdisciplineClassModulesId.ts";
import { saveClassModuleViewModelSchema } from "../saveClassModuleViewModelSchema.ts";

export const putApiV1ClassroomdisciplineClassModulesIdPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
  }) as unknown as ToZod<PutApiV1ClassroomdisciplineClassModulesIdPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ClassroomdisciplineClassModulesId202Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineClassModulesId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ClassroomdisciplineClassModulesId400Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineClassModulesId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ClassroomdisciplineClassModulesId401Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineClassModulesId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ClassroomdisciplineClassModulesId404Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineClassModulesId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ClassroomdisciplineClassModulesId500Schema =
  z.any() as unknown as ToZod<PutApiV1ClassroomdisciplineClassModulesId500>;

export const putApiV1ClassroomdisciplineClassModulesIdMutationRequestSchema =
  z.lazy(
    () => saveClassModuleViewModelSchema,
  ) as unknown as ToZod<PutApiV1ClassroomdisciplineClassModulesIdMutationRequest>;

export const putApiV1ClassroomdisciplineClassModulesIdMutationResponseSchema =
  z.lazy(
    () => putApiV1ClassroomdisciplineClassModulesId202Schema,
  ) as unknown as ToZod<PutApiV1ClassroomdisciplineClassModulesIdMutationResponse>;
